export const MATTER_TRUST_CHECK_TYPE_OPTIONS = ["Deposit", "Withdraw"] as const;
